import { VALIDATION } from "../constants";

/**
 * Calculate total amount from selected items
 */
export const calculateStockEntryTotal = (selectedItems) => {
    return selectedItems.reduce((total, item) => total + item.amount, 0);
};

/**
 * Round number to specified decimal places
 */
export const roundToDecimalPlaces = (
    value,
    places = VALIDATION.DECIMAL_PLACES
) => {
    return Math.round(value * Math.pow(10, places)) / Math.pow(10, places);
};

/**
 * Calculate item amount based on quantity and rate
 */
export const calculateItemAmount = (qty, rate) => {
    return roundToDecimalPlaces(qty * rate);
};

/**
 * Check if payment is fully paid (accounting for floating point precision)
 */
export const isFullyPaid = (outstandingAmount) => {
    return outstandingAmount <= VALIDATION.FLOATING_POINT_PRECISION;
};

/**
 * Calculate outstanding amount
 */
export const calculateOutstandingAmount = (totalAmount, paidAmount) => {
    return totalAmount - paidAmount;
};

/**
 * Get current date in ISO format
 */
export const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
};

/**
 * Get current time in HH:MM:SS format
 */
export const getCurrentTime = () => {
    return new Date().toTimeString().split(" ")[0];
};

/**
 * Generate random transaction ID
 */
export const generateTransactionId = () => {
    return Math.random().toString(36).substr(2, 9);
};
